import React from "react";
import ConfirmDetailsView from "./view";
import { noop } from "@client/shared/constants";

const ConfirmDetailsPanel = ({
  broadcastTitle = "",
  recordingType = 1,
  recordedVoicemail = null,
  callToRecordVoicemail = null,
  selectedVoicemail = {},
  uploadedVoicemail = null,
  recipients = [],
  callerDetails = {},
  immediateRelease = false,
  releaseDate = "",
  notifyRecipient = false,
  bbc = [],
  includeSelfInBroadcast = false,
  timezone = null,
  handleChange = noop,
  showDetails = false,
  isNewForm = false,
  isFormChanged = false,
  broadcastComplete = false,
  broadcastErrors = [],
  isAllRecipients = false,
}) => {
  return (
    <ConfirmDetailsView
      broadcastTitle={broadcastTitle}
      recordingType={recordingType}
      recordedVoicemail={recordedVoicemail}
      callToRecordVoicemail={callToRecordVoicemail}
      selectedVoicemail={selectedVoicemail}
      uploadedVoicemail={uploadedVoicemail}
      recipients={recipients}
      callerDetails={callerDetails}
      immediateRelease={immediateRelease}
      releaseDate={releaseDate}
      notifyRecipient={notifyRecipient}
      bbc={bbc}
      includeSelfInBroadcast={includeSelfInBroadcast}
      timezone={timezone}
      handleChange={handleChange}
      showDetails={showDetails}
      isNewForm={isNewForm}
      isFormChanged={isFormChanged}
      broadcastComplete={broadcastComplete}
      broadcastErrors={broadcastErrors}
      isAllRecipients={isAllRecipients}
    />
  );
};

export default ConfirmDetailsPanel;
